import PrimaryButton from "@/components/buttons/primary-button/PrimaryButton";
import { literals } from "@/constants/literals";
import TerciaryButton from "@/components/buttons/terciary-button/TerciaryButton";
import type { ExitsOrderData } from "@/types/types.d";
import RadioGroup from "@/pages/capture/components/RadioGroup";

export type ConfirmPackagingStepProps = {
  orderData: ExitsOrderData;
  changeOwnPackagingOut: () => void;
  changeIberiaPackaging: () => void;
  saveOrder: () => void;
  openConfirmDiscardModal: () => void;
};

const ConfirmPackagingStep = ({
  orderData,
  changeOwnPackagingOut,
  changeIberiaPackaging,
  saveOrder,
  openConfirmDiscardModal,
}: ConfirmPackagingStepProps) => {
  return (
    <div className="w-full grid gap-4">
      <div>
        <p className="text-sm text-ib-pt-color-gray-1000">
          {literals.completeBeforeSave}
        </p>
      </div>
      <RadioGroup
        label={literals.sentWithOWnPackage}
        selected={orderData.ownPackagingOut}
        onChange={changeOwnPackagingOut}
      />
      {!orderData.ownPackagingOut ? (
        <RadioGroup
          label={literals.iberiaPackagingConfirm}
          selected={orderData.iberiaPackagingOut}
          onChange={changeIberiaPackaging}
        />
      ) : null}
      <PrimaryButton
        colour="red"
        label={literals.confirmAndExit}
        onClick={saveOrder}
        icon="checkUnderline"
      />
      <TerciaryButton
        colour="red"
        label={literals.discardOrder}
        onClick={openConfirmDiscardModal}
      />
    </div>
  );
};

export default ConfirmPackagingStep;
